import api from './api'

const authService = {
  login: (credentials) => {
    return api.post('/auth/login', credentials)
  },

  logout: () => {
    return api.post('/auth/logout')
  },

  refreshToken: (refreshToken) => {
    return api.post('/auth/refresh', { refresh_token: refreshToken })
  },

  register: (userData) => {
    return api.post('/auth/register', userData)
  },

  changePassword: (passwordData) => {
    return api.post('/auth/change-password', passwordData)
  },

  updateProfile: (profileData) => {
    return api.post('/auth/update-profile', profileData)
  },

  updatePreferences: (preferences) => {
    return api.post('/auth/update-preferences', preferences)
  },

  getPreferences: () => {
    return api.get('/auth/preferences')
  },

  getMyRoles: () => {
    return api.get('/auth/my-roles')
  },

  forgotPassword: (email) => {
    return api.post('/auth/forgot-password', { email })
  },

  resetPassword: (data) => {
    return api.post('/auth/reset-password', data)
  },

  // User notification settings
  getUserSettings: () => {
    return api.get('/user/settings')
  },

  saveLineNotify: (data) => {
    return api.post('/user/settings/line-notify', data)
  },

  testLineNotify: () => {
    return api.post('/user/settings/line-notify/test')
  },

  // 2FA / TOTP
  get2FAStatus: () => {
    return api.get('/auth/2fa/status')
  },

  setup2FA: () => {
    return api.post('/auth/2fa/setup')
  },

  enable2FA: (otp_code) => {
    return api.post('/auth/2fa/enable', { otp_code })
  },

  verify2FA: (temp_token, otp_code, recovery_code) => {
    const body = { temp_token }
    if (otp_code) body.otp_code = otp_code
    if (recovery_code) body.recovery_code = recovery_code
    return api.post('/auth/2fa/verify', body)
  },

  disable2FA: (password) => {
    return api.post('/auth/2fa/disable', { password })
  },
}

export default authService
